const TITLE = 'Checkout';
const DESC =
  'Enable the WhenThen checkout APIs to enable Automations that allow you to optimize your check-out experience to increase conversion.';

const BUTTON_TITLE_DISABLED_STATE = 'To configure checkout, you must first connect a processor.';
const BUTTON_TITLE_EMPTY_STATE = 'No checkout set up yet.';

export { TITLE, DESC, BUTTON_TITLE_DISABLED_STATE, BUTTON_TITLE_EMPTY_STATE };
